// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.nibInput_old-container__vRGWn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.nibInput_old-container__vRGWn.nibInput_wrap__vZRSu {
  flex-wrap: wrap;
}
.nibInput_old-container__vRGWn .nibInput_box__GiiIW.nibInput_col__eSto6 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.nibInput_old-container__vRGWn .nibInput_box__GiiIW.nibInput_col__eSto6 > div {
  width: 100%;
}
.nibInput_old-container__vRGWn .nibInput_box__GiiIW.nibInput_row__eCpv8 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.nibInput_old-container__vRGWn form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.nibInput_old-container__vRGWn form > .nibInput_box__GiiIW.nibInput_col__eSto6 {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .nibInput_old-container__vRGWn form > .nibInput_box__GiiIW.nibInput_col__eSto6 {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .nibInput_old-container__vRGWn, .nibInput_col__eSto6, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .nibInput_old-container__vRGWn, .nibInput_col__eSto6, form {
    padding: 0px;
  }
}
.nibInput_text-overflow-hidden__KsZ8d {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nibInput_icon__WoK1N {
  color: var(--accent-color);
}

.nibInput_richtext-output-wrap__bSSZT .nibInput_se-video-container__DyKJe figure {
  padding-bottom: 0 !important;
}

.nibInput_wrap__vZRSu {
  position: relative;
}
.nibInput_wrap__vZRSu input, .nibInput_wrap__vZRSu fieldset {
  border-color: var(--accent-color) !important;
}
.nibInput_wrap__vZRSu input:focus, .nibInput_wrap__vZRSu fieldset:focus {
  border-color: var(--accent-color) !important;
}
.nibInput_wrap__vZRSu .nibInput_toggelPass__GKdlW {
  position: absolute;
  top: 50%;
  right: 5px;
  transform: translateY(-50%);
}
.nibInput_wrap__vZRSu.nibInput_pass__7gNJ9 input {
  padding-right: 37px;
}

.nibInput_container__QpGZC {
  position: relative;
  width: 100%;
  padding: 0;
}
.nibInput_container__QpGZC .nibInput_overlay__VAnIi {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 80;
  cursor: pointer;
  top: 0;
  left: 0;
}
.nibInput_container__QpGZC .nibInput_inner__sKUKi {
  z-index: 10;
  width: 100%;
  height: 100%;
}
.nibInput_container__QpGZC .nibInput_inner__sKUKi.nibInput_add__\\+ZbnN input {
  padding-right: 50px;
}

.nibInput_paperLike__tR2Yg {
  background-color: #ffffff;
  border-radius: 0;
}
.nibInput_paperLike__tR2Yg > div {
  box-shadow: -5px 5px 10px 0px rgba(0, 0, 0, 0.35);
  padding: 8px !important;
}
.nibInput_paperLike__tR2Yg input, .nibInput_paperLike__tR2Yg textarea {
  color: black;
}
.nibInput_paperLike__tR2Yg input ::placeholder, .nibInput_paperLike__tR2Yg textarea ::placeholder {
  color: grey;
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/common/NibInput/nibInput.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAzEA;EACI,kBAAA;AA4EJ;AA3EI;EAGI,4CAAA;AA2ER;AA1EQ;EACI,4CAAA;AA4EZ;AAtEI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;AAwER;AAtEQ;EACI,mBAAA;AAwEZ;;AAvEA;EACI,kBAAA;EACA,WAAA;EACA,UAAA;AA0EJ;AAzEI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;AA2ER;AA1EI;EACI,WAAA;EACA,WAAA;EACA,YAAA;AA4ER;AA1EY;EACI,mBAAA;AA4EhB;;AA1EA;EACI,yBAAA;EACA,gBAAA;AA6EJ;AA5EI;EDtCF,iDAAA;ECwCM,uBAAA;AA8ER;AA7EI;EACI,YAAA;AA+ER;AA9EQ;EACI,WAAA;AAgFZ","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../../sass/settings'\n\n.wrap\n    position: relative\n    input, fieldset\n        // width: 100%\n        // background-color: transparent\n        border-color: $accent !important\n        &:focus\n            border-color: $accent !important\n        // border-radius: 4px\n        // min-height: 55px\n        // text-indent: $gutter\n        // font-size: 18px\n        // color: #fff\n    .toggelPass\n        position: absolute\n        top: 50%\n        right: 5px\n        transform: translateY(-50%)\n    &.pass\n        input\n            padding-right: 32px + 5px\n.container\n    position: relative\n    width: 100%\n    padding: 0\n    .overlay\n        position: absolute\n        width: 100%\n        height: 100%\n        z-index: 80\n        cursor: pointer\n        top: 0\n        left: 0\n    .inner\n        z-index: 10\n        width: 100%\n        height: 100%\n        &.add\n            input\n                padding-right: 50px\n\n.paperLike\n    background-color: #ffffff\n    border-radius: 0\n    > div\n        +shadow()\n        padding: 8px !important\n    input, textarea\n        color: black\n        ::placeholder\n            color: grey\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `nibInput_old-container__vRGWn`,
	"wrap": `nibInput_wrap__vZRSu`,
	"box": `nibInput_box__GiiIW`,
	"col": `nibInput_col__eSto6`,
	"row": `nibInput_row__eCpv8`,
	"text-overflow-hidden": `nibInput_text-overflow-hidden__KsZ8d`,
	"icon": `nibInput_icon__WoK1N`,
	"richtext-output-wrap": `nibInput_richtext-output-wrap__bSSZT`,
	"se-video-container": `nibInput_se-video-container__DyKJe`,
	"toggelPass": `nibInput_toggelPass__GKdlW`,
	"pass": `nibInput_pass__7gNJ9`,
	"container": `nibInput_container__QpGZC`,
	"overlay": `nibInput_overlay__VAnIi`,
	"inner": `nibInput_inner__sKUKi`,
	"add": `nibInput_add__+ZbnN`,
	"paperLike": `nibInput_paperLike__tR2Yg`
};
export default ___CSS_LOADER_EXPORT___;
